import { Link } from "react-router-dom";

export type Sort = "newest" | "active" | "unanswered" | "most_votes";

const LABEL: Record<Sort, string> = {
  newest: "Newest",
  active: "Active",
  unanswered: "Unanswered",
  most_votes: "Most votes",
};

/**
 * Stack-Overflow-style sort tab strip used above the question feed.
 * Active tab gets the amber underline; the "Ask a question" button
 * sits on the right. All four sorts are server-side (migration 0010
 * denormalized answer_count + question_score onto the documents row).
 */
export function SortTabs({
  current,
  onChange,
}: {
  current: Sort;
  onChange: (next: Sort) => void;
}) {
  const tabs: Sort[] = ["newest", "active", "unanswered", "most_votes"];
  return (
    <div className="flex items-center justify-between border-b border-zinc-200 dark:border-zinc-800 mb-4 -mx-1 px-1">
      <ul className="flex items-center gap-1">
        {tabs.map((s) => {
          const active = current === s;
          return (
            <li key={s}>
              <button
                type="button"
                onClick={() => onChange(s)}
                className={[
                  "relative px-3 py-2 text-sm-dense font-medium transition",
                  active
                    ? "text-zinc-900 dark:text-zinc-100"
                    : "text-zinc-500 hover:text-zinc-900 dark:hover:text-zinc-200",
                ].join(" ")}
              >
                {LABEL[s]}
                {active && (
                  <span
                    aria-hidden="true"
                    className="absolute left-2 right-2 -bottom-px h-0.5 bg-accent"
                  />
                )}
              </button>
            </li>
          );
        })}
      </ul>
      <Link
        to="/ask"
        className="rounded-md bg-accent text-white text-sm-dense px-3 py-1.5 font-medium hover:opacity-90"
      >
        Ask a question
      </Link>
    </div>
  );
}
